module.exports = __webpack_public_path__ + "img/top.445ee4bc.png";